import { ChatbotResource } from "core/stages-client";
import { inject, Injectable } from "@angular/core";
import ChatHistoryEntry = stages.chatbot.ChatHistoryEntry;

@Injectable({ providedIn: "root" })
export class ChatHistoryService {
	private readonly chatbotResource = inject(ChatbotResource);

	async delete(
		guids: string[],
		page: number,
		pageSize: number,
		firstPageSize: number,
	): Promise<PagedResult<ChatHistoryEntry>> {
		return this.chatbotResource.deleteChatHistoryEntries(guids, {
			page: page,
			pageSize: pageSize,
			firstPageSize: firstPageSize,
		});
	}
}
